export default {"src":"/_next/static/image/components/ui/Icon/icons/instagram.fdace6baf8b32115edaac61929a84aa0.svg","height":16,"width":16};